import { createStyles } from "@mantine/styles";

export const useLandingLayoutStyles = createStyles((theme) => ({
    root: {},
}));
